import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';

import "./SobreWhisky.css"; 

const SobreWhisky = () => {
  return (
    <section className="sobre-whisky">
      <Container>
        <Row className="align-items-center mobileSmall">
          {/* Imagen */}
          <Col md={4} sm={4} xs={4} className="image-container">
           <div className="d-flex justify-content-center py-4" >
           <img 
              src="/img/inicio/imgInfoWhisky.jpg" 
              alt="Barril de Whisky"
              className="img-fluid"
            />
           </div>
          </Col>

          {/* Texto */}
          <Col  md={8} sm={8} xs={8} className="text-container">
            <h1>El Arte del Whisky</h1>
            <p>
              Cada botella de whisky representa años de tradición, pasión y maestría. 
              En nuestra selección, encontrarás destilados únicos que han sido 
              cuidadosamente añejados para brindarte una experiencia inigualable.
            </p>
            <p>
              Desde barricas seleccionadas hasta los métodos artesanales de destilación, 
              cada detalle es un tributo al valor y la importancia de esta bebida legendaria.
            </p>
            <Link to="/nosotros" className="sobreW-btn">Conocenos</Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SobreWhisky;
